/* Copyright (c) 2023, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

export enum ImageFileFormat {
    png = 'png',
    png8 = 'png8',
    png24 = 'png24',
    png32 = 'png32',
    png48 = 'png48',
    png64 = 'png64',
    jpe = 'jpe',
    jpeg = 'jpeg',
    jpg = 'jpg',
    ico = 'ico',
    icon = 'icon',
    webp = 'webp'
}

export interface ImageProperties {
    w?: number; // Image width in pixels
    h?: number; // Image height in pixels
    cr?: boolean; // Crop should the image be cropped (default is letterbox)
    ar?: boolean; // IgnoreAspectRatio should the image be stretched to fill 100% of the size
    q?: number; // Quality a number 1 - 100 where 1 high quality large file, 100 is low quality small file
    f?: ImageFileFormat; // Format for the image file
    bg?: string; // A hex string indicating the background color e.g 0x00FFFFFF
}
